import { constants } from '../../constants'
import { message } from 'antd'
const handleNavigate = async () => {
  if (!window.ReactNativeWebView) return
  const path = `/${constants.ADMIN_LITE}`
  window.location.href = path
  await window.ReactNativeWebView.postMessage(
    JSON.stringify({
      route: '/navigate',
      data: { path },
    })
  )
}
/**
 * The one way out of an authenticated admin session.
 *
 * Three things now end a session — an expired/rejected token, maintenance mode,
 * and the idle timeout (component/common/idle.timeout.js) — and they must leave
 * the browser in exactly the same state. Divergence here is how a "logout" that
 * strands a stale profile in storage happens.
 *
 * Clears BOTH storages. That deliberately includes the AdminLite `trustToken`
 * in localStorage, so the next sign-in needs the SMS OTP again rather than
 * riding a 90-day device trust. This matches what the TOKEN_EXPIRED path has
 * always done.
 */
export const forceLogout = (errorMessage) => {
  if (errorMessage) message.error(errorMessage)
  localStorage.clear()
  sessionStorage.clear()
  window.location.href = '/login'
  // Not awaited, matching the original call sites: it reassigns location for
  // the native shell, and there is nothing useful to wait for.
  handleNavigate()
}

export const handleApolloResponse = async (data) => {
  // return data;
  try {
    if (data?.status && data.status.toLowerCase() == constants.MESSAGE.TOKEN_EXPIRED.toLowerCase()) {
      forceLogout(constants.MESSAGE.TOKEN_EXPIRED)
    } else if (data?.status && data.status.toLowerCase() == constants.MESSAGE.MAINTENANCE.toLowerCase()) {
      // Server is in maintenance mode: force-logout like TOKEN_EXPIRED, but
      // with the maintenance copy (server may carry a custom message). When
      // already on the login screen, pass the response through so the login
      // flow can surface the message instead of hard-reloading.
      if (window.location.pathname === '/login') return data
      forceLogout(data.message || constants.MESSAGE.MAINTENANCE_LOGOUT)
    } else return data
  } catch (err) {
    console.log(err, 'error in  handleApolloResponse ', data)
    return data
  }
}
